
//Open Badges Endorsement Collection
//note the difference between these are the mymantl "endorsements" of users

//React Version. Note this is using the ES6 style class system for Reflux stores. It is unlike most of the older JSX components in MyMantl

let OBEndorsementActions = Reflux.createActions([
    'fetchOBEndorsements',
    'fetchExternalOBEndorsements'
]);

class OBEndorsementListStore extends Reflux.Store {
    constructor() {
        super();
        this.state = {
            endorsements: {
                issuer: [],
                badge: [],
                assertion: []
            }
        };
        this.listenables = OBEndorsementActions;
    }

    onFetchOBEndorsements(endorseetype,endorseeid) {
        let _self = this;
        httpGet(buildRoute(mantlroutes.endorsement_list,{ endorseetype: endorseetype, endorseeid: endorseeid })).then(
            function(value) {
                var response = JSON.parse(value);
                if(endorseetype == 'issuer'){
                    // _self.setState({ endorsements: { issuer: response } });
                    _self.setState({ endorsements: { ..._self.state.endorsements, issuer: response} });
                }
                if(endorseetype == 'badge'){
                    // _self.setState({ endorsements: { issuer: response } });
                    _self.setState({ endorsements: { ..._self.state.endorsements, badge: response} });
                }
                if(endorseetype == 'assertion'){
                    // _self.setState({ endorsements: { issuer: response } });
                    _self.setState({ endorsements: { ..._self.state.endorsements, assertion: response} });
                }

            })
        .catch(
            function(reason) {
                alertify.error('Unable to Retrieve Endorsements')
            });
    }

    onFetchExternalOBEndorsements(endorseetype,endorseeid) {
        let _self = this;
        httpGet(buildRoute(mantlroutes.ext_endorsement_list,{ endorseetype: endorseetype, endorseeid: endorseeid })).then(
            function(value) {
                var response = JSON.parse(value);
                if(endorseetype == 'issuer'){
                    // _self.setState({ endorsements: { issuer: response } });
                    _self.setState({ endorsements: { ..._self.state.endorsements, issuer: response} });
                }
                if(endorseetype == 'badge'){
                    // _self.setState({ endorsements: { issuer: response } });
                    _self.setState({ endorsements: { ..._self.state.endorsements, badge: response} });
                }
                if(endorseetype == 'assertion'){
                    // _self.setState({ endorsements: { issuer: response } });
                    _self.setState({ endorsements: { ..._self.state.endorsements, assertion: response} });
                }
            })
        .catch(
            function(reason) {
                alertify.error('Unable to Retrieve Endorsements')
            });
    }
}


class OBEndorsementList {
    constructor(options) {
        this.defaults = {
            endorseetype: null,
            endorseeid: null,
            target: 'endorsement_list',
            isExternal: false,
            isEndorsee: false,
            endorseeCrudAs: null,
            canEndorse: false,
            isAuthenticated: false,
            myEarners: [],
            myOwnerships: []
        }
        this.settings = extend( {}, this.defaults, options );
        this.endpoint = buildRoute(mantlroutes.endorsement_list,{ endorseetype: this.settings.endorseetype, endorseeid: this.settings.endorseeid });
        this.Actions = OBEndorsementActions;
        this.modalsID = "OBEndorsementListModal";
        this.render();
        this.initStore();
    }

    render() {
        let target = this.settings.target;
        ReactDOM.render(<OBEndorsementListWrapper settings={this.settings} endorseetype={this.settings.endorseetype} endorseeid={this.settings.endorseeid} />, document.getElementById(target));
    }

    initStore() {
        if(this.settings.isExternal){
            this.Actions.fetchExternalOBEndorsements(this.settings.endorseetype, this.settings.endorseeid);
        } else {
            this.Actions.fetchOBEndorsements(this.settings.endorseetype, this.settings.endorseeid);
        }
    }

}

//Reflux.Component extends React.Component
class OBEndorsementListWrapper extends Reflux.Component {
    constructor(props) {
        super(props);
        this.store = new OBEndorsementListStore(); // <- just assign the store class itself
        this.getItems = this.getItems.bind(this);
        this.handleNew = this.handleNew.bind(this);
    }

    getItems() {
        let endorsements = [];
        this.state.endorsements[this.props.endorseetype].forEach((element,index) => {
            let endorseetype = this.props.settings.endorseetype;
            let endorseeid = this.props.settings.endorseeid;
            let endorsertype = "org";
            let endorserid = null;
            let isEndorser = false;
            let isEndorsee = this.props.settings.isEndorsee;
            if(element.endorser_earner != undefined) {
                endorsertype = "earner";
                endorserid = element.endorser_earner.id;
                if(this.props.settings.myEarners.indexOf(endorserid) != -1) {
                    isEndorser = true;
                }
            } else {
                endorsertype = "org";
                endorserid = element.endorser_org.id;
                if(this.props.settings.myOwnerships.indexOf(endorserid) != -1) {
                    isEndorser = true;
                }
            }
            endorsements.push( <OBEndorsementListItem key={index} settings={this.props.settings} endorsement={element} endorsertype={endorsertype} endorserid={endorserid} endorseetype={endorseetype} endorseeid={endorseeid} isEndorser={isEndorser} isEndorsee={isEndorsee} external={this.props.settings.isExternal} /> );
        });
        return endorsements;
    }

    handleNew(){
        let _self = this;
        let endpoint = buildView((this.props.settings.isExternal) ? mantlroutes.ext_endorsement_create_modal : mantlroutes.endorsement_create_modal, {
            endorseetype: this.props.endorseetype,
            endorseeid: this.props.endorseeid
        });
        //Build Modal
        httpGet(endpoint).then(
            function(value) {
                var response = value;
                var $modal = buildModal(response,{
                    classes: 'modal modal--full',
                    header: "Add Endorsement"
                });
                $('body').append($modal);
                $modal.on("modal:close",function(){
                    $modal.off("modal:close").remove();
                    if(_self.props.settings.isExternal){
                        OBEndorsementActions.fetchExternalOBEndorsements(_self.props.endorseetype, _self.props.endorseeid);
                    } else {
                        OBEndorsementActions.fetchOBEndorsements(_self.props.endorseetype, _self.props.endorseeid);
                    }

                })
                $modal.openModal();
            })
        .catch(
            function(reason) {
                console.error('Error loading endorsement creator.', reason);
                alertify.error('Unable to Open Endorsement Creator')
            });
    }

    render() {
        var count = this.state.endorsements[this.props.endorseetype].length;
        let endorsements = this.getItems();
        let headingLabel = "Issuer's Endorsements";
        if(this.props.settings.endorseetype == 'badge'){
            headingLabel = "Badge's Endorsements";
        }
        if(this.props.settings.endorseetype == 'assertion'){
            headingLabel = "Issued Assertion's Endorsements";
        }
        if(count > 0){
            return (
                <section className="endorsements">
                    {this.props.settings.canEndorse && (
                        <h2 className="endorsements-heading"><span>{headingLabel}</span></h2>
                    )}
                    {this.props.settings.canEndorse && (
                        <div className="endorsements-items">{endorsements}</div>
                    )}
                    {this.props.settings.isAuthenticated && this.props.settings.canEndorse && (
                        <button type="button" className="button--faint button--full" onClick={this.handleNew}><i className="icon-thumbs-up"></i> Endorse this {this.props.endorseetype.capitalize()}</button>
                    )}
                    {this.props.settings.isAuthenticated && !this.props.settings.canEndorse && (
                        <p className="text--center text--muted">{this.props.endorseetype.capitalize()} endorsements have been disabled.</p>
                    )}
                    {!this.props.settings.isAuthenticated && this.props.settings.canEndorse && (
                        <p className="text--center text--muted">You must be logged in to endorse.</p>
                    )}
                </section>
            );
        } else {
            return (
                <section className="endorsements">
                    {this.props.settings.isAuthenticated && this.props.settings.canEndorse && (
                        <button type="button" className="button--faint button--full" onClick={this.handleNew}><i className="icon-thumbs-up"></i> Endorse this {this.props.endorseetype.capitalize()}</button>
                    )}
                    {this.props.settings.isAuthenticated && !this.props.settings.canEndorse && !this.props.settings.isExternal && (
                        <p className="text--center text--muted">{this.props.endorseetype.capitalize()} endorsements have been disabled.</p>
                    )}
                    {!this.props.settings.isAuthenticated && this.props.settings.canEndorse && (
                        <p className="text--center text--muted">You must be logged in to endorse.</p>
                    )}
                </section>
            );
        }

    }
}

class OBEndorsementListItem extends React.Component {
    constructor(props) {
        super(props);
        this.handleDelete = this.handleDelete.bind(this);
        this.handleEdit = this.handleEdit.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.state = {
            editing: false
        };
    }

    handleDelete(){
        let endorsement = this.props.endorsement;
        let crud_endorser = buildRoute((this.props.external) ? mantlroutes.ext_endorsement_item_crud : mantlroutes.endorsement_item_crud, {
            endorsertype: this.props.endorsertype,
            endorserid: this.props.endorserid,
            endorseetype: this.props.endorseetype,
            endorseeid: this.props.endorseeid,
            endorsementid: this.props.endorsement.id
        });
		/*
		CRUD for endorsee (i.e. can delete)
		endorsement on org: org, endorseeid
		endorsement on badge: org, badge.issuer.id
		endorsement on assertion: earner, any earner for user (if isEndorsee)
		*/
		/*
		endorsertype: this.props.settings.endorseeDeleteAs, //this is wrong
		endorserid: this.props.settings.endorseeCrudAs,
		*/
		let endorseeCrudType = "org";
		if(this.props.endorseetype == "assertion") {
			endorseeCrudType = "earner";
		}
        let crud_endorsee = buildRoute((this.props.external) ? mantlroutes.ext_endorsement_item_crud : mantlroutes.endorsement_item_crud, {
            endorsertype: endorseeCrudType,
            endorserid: this.props.settings.endorseeCrudAs,
            endorseetype: this.props.endorseetype,
            endorseeid: this.props.endorseeid,
            endorsementid: this.props.endorsement.id
        });
        let _self = this;
        if(_self.props.isEndorser || _self.props.isEndorsee) {
            alertify.okBtn("Yes, Delete").cancelBtn("Cancel").confirm("<h1 class='h3'>Are you sure you want to <b class='text--danger'>delete</b> this endorsement?</h1><p>This cannot be undone.</p>")
            .then(function (resolvedValue) {
                resolvedValue.event.preventDefault();
                if(resolvedValue.buttonClicked == "ok"){
                    let endpoint = crud_endorsee;
                    if(_self.props.isEndorser) {
                        endpoint = crud_endorser;
                    }
                    httpDelete(endpoint).then(
                        function(value){
                            if(_self.props.external){
                                OBEndorsementActions.fetchExternalOBEndorsements(_self.props.endorseetype, _self.props.endorseeid);
                            } else {
                                OBEndorsementActions.fetchOBEndorsements(_self.props.endorseetype, _self.props.endorseeid);
                            }
                            alertify.log('Endorsement Deleted');
                        })
                    .catch(
                        function(reason) {
                            console.error("Unable to delete endorsement",reason);
                            alertify.error("Unable to delete endorsement.");
                        });
                } else {
                    alertify.log("Cancelled")
                }
            });
        } else {
            alertify.error("You are not permitted to delete this.")
        }

    }

    handleEdit(){
        if(this.props.isEndorser) {
            this.setState({ editing: true });
        } else {
            alertify.log("You do not have permission to edit this.")
        }
    }

    handleSave(newComment) {
        let _self = this;
        let endpoint = buildRoute((this.props.external) ? mantlroutes.ext_endorsement_item_crud : mantlroutes.endorsement_item_crud, {
            endorsertype: this.props.endorsertype,
            endorserid: this.props.endorserid,
            endorseetype: this.props.endorseetype,
            endorseeid: this.props.endorseeid,
            endorsementid: this.props.endorsement.id
        });
        httpPatch(endpoint, {
            comment: newComment
        }).then(
            function(value){
                if(_self.props.external){
                    OBEndorsementActions.fetchExternalOBEndorsements(_self.props.endorseetype, _self.props.endorseeid);
                } else {
                    OBEndorsementActions.fetchOBEndorsements(_self.props.endorseetype, _self.props.endorseeid);
                }
                _self.setState({ editing: false });
                alertify.success('Endorsement Updated');
            })
        .catch(
            function(reason) {
                console.error("Unable to update endorsement",reason);
                alertify.error("Unable to update endorsement.");
            });
    }

    handleCancel() {
        this.setState({ editing: false });
    }

    render() {
        let endorsement = this.props.endorsement;
        if(this.props.endorsertype == "org"){
            return (
                <article className="endorsements-item" data-endorsement-id={endorsement.id}>
                    <footer className="endorsements-item-author">
                        <img className="endorsements-avatar" src={endorsement.endorser_org.image} alt="Avatar" />
                        {(() => {
                            if (this.props.isEndorser || this.props.isEndorsee) {
                                return (
                                    <button onClick={this.handleDelete} className="button button--sm button--skinny button--flat text--danger float--right">Delete</button>
                                );
                            }
                        })()}
                        {(() => {
                            if (this.props.isEndorser) {
                                return (
                                    <button onClick={this.handleEdit} className="button button--sm button--skinny float--right">Edit</button>
                                );
                            }
                        })()}
                        <p>Endorsed by <a href={endorsement.issuer_iri}>{endorsement.endorser_org.name}</a> on <a href={endorsement.unique_iri}><FormattedDate date={endorsement.issuedOn} /></a></p>
                    </footer>
                    <div className="endorsements-item-comment">
                        {(() => {
                            if (this.state.editing) {
                                return (
                                    <OBEndorsementListItemEditor onSave={this.handleSave} onCancel={this.handleCancel} comment={endorsement.comment} />
                                );
                            } else {
                                return (
                                    <p>{endorsement.comment}</p>
                                );
                            }
                        })()}
                    </div>
                </article>
            );
        } else {
            let avatar_src = "";
            let endorser_label = "";
            if(endorsement.endorser_earner.user == undefined){
                avatar_src = "assets/images/icon-endorsement.svg";
                if(endorsement.endorser_earner.first_name) { endorser_label += endorsement.endorser_earner.first_name; }
                if(endorsement.endorser_earner.last_name) { endorser_label += " " + endorsement.endorser_earner.last_name; }
                if(endorsement.endorser_earner.email) { endorser_label += " " + endorsement.endorser_earner.email; }
            } else {
                avatar_src = endorsement.endorser_earner.user.avatar;
                endorser_label = endorsement.endorser_earner.user.full_name;
            }
            return (
                <article className="endorsements-item" data-endorsement-id={endorsement.id}>
                    <footer className="endorsements-item-author">
                        <img className="endorsements-avatar" src={avatar_src} alt="Avatar" />
                        {(() => {
                            if (this.props.isEndorser || this.props.isEndorsee) {
                                return (
                                    <button onClick={this.handleDelete} className="button button--sm button--skinny button--flat text--danger float--right">Delete</button>
                                );
                            }
                        })()}
                        {(() => {
                            if (this.props.isEndorser) {
                                return (
                                    <button onClick={this.handleEdit} className="button button--sm button--skinny float--right">Edit</button>
                                );
                            }
                        })()}
                        <p>Endorsed by <a href={endorsement.issuer_iri}>{endorser_label}</a> on <a href={endorsement.unique_iri}><FormattedDate date={endorsement.issuedOn} /></a></p>
                        {(() => {
                            if (endorsement.endorser_earner.user) {
                                return (
                                    <p className="endorsements-author-description">{endorsement.endorser_earner.user.professional_title}</p>
                                );
                            }
                        })()}
                    </footer>
                    <div className="endorsements-item-comment">
                        {(() => {
                            if (this.state.editing) {
                                return (
                                    <OBEndorsementListItemEditor onSave={this.handleSave} onCancel={this.handleCancel} comment={endorsement.comment} />
                                );
                            } else {
                                return (
                                    <p>{endorsement.comment}</p>
                                );
                            }
                        })()}
                    </div>
                </article>
            );
        }

    }
}

class OBEndorsementListItemEditor extends React.Component {
    constructor(props) {
        super(props);
        this.handleSave = this.handleSave.bind(this);
    }

    handleSave() {
        let component = ReactDOM.findDOMNode(this);
        let input = component.querySelector(".endorsementComment");
        let newComment = input.value;
        if(newComment.length > 0){
            this.props.onSave(newComment);
        } else {
            alertify.error('Endorsement comment cannot be blank.')
        }
    }
    render() {
        return (
            <div className="text--loosetop animated animated--quickly boingInUp">
                <textarea className="endorsementComment" defaultValue={this.props.comment}></textarea>
                <button type="button" className="button button--success" onClick={this.handleSave}>Update Endorsement</button> <button type="button" className="button button--flat" onClick={this.props.onCancel}>Cancel</button>
            </div>
        );
    }
}
